import { useTranslation } from 'react-i18next';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { Typography } from 'app/components/ui';

import './Modal.scss';

interface DeleteExtensionMemberModalProps {
  show: boolean;
  memberLabel: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteExtensionMemberModal = ({ show, memberLabel, busy = false, onConfirm, onCancel }: DeleteExtensionMemberModalProps) => {
  const { t } = useTranslation('tag');

  return (
    <BootstrapModal show={show} onHide={onCancel} contentClassName="tags-modal__content tags-modal__content--continuation" centered>
      <button onClick={onCancel} type="button" aria-label="Close" className="tags-modal__close-btn">
        <i className="fa-solid fa-xmark" />
      </button>

      <div className="tags-modal__header">
        <i className="fa-solid fa-trash tags-modal__tag-icon tags-modal__tag-icon--danger" />

        <div className="tags-modal__title-group">
          <Typography variant="body-7" fontWeight="semibold" color="#1e2533">
            {t('dimensions.delete-member.title')} — {memberLabel}
          </Typography>

          <Typography variant="body-7" fontWeight="light" color="#616066">
            {t('dimensions.delete-member.confirm')}
          </Typography>
        </div>
      </div>

      <div className="tags-modal__actions">
        <button className="tags-modal__btn-cancel" onClick={onCancel}>
          {t('delete.modal.cancel')}
        </button>
        <button className="tags-modal__btn-confirm tags-modal__btn-confirm--danger" disabled={busy} onClick={onConfirm}>
          {t('delete.modal.confirm')}
        </button>
      </div>
    </BootstrapModal>
  );
};
